exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\n    border-bottom: none !important;\n}\n.color-border-bottom{\n    border-bottom: 2px solid #ffebae !important;\n}\n.text-white{\n    color: white !important;\n}\n.box-modal-menu{\n    max-height: 468px !important;\n    overflow: scroll;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/cart-modal/cart-modal.component.css
// module id = ../../../../../src/app/components/cart-modal/cart-modal.component.css
// module chunks = main